import MessagePopupsList from '#@/components/MessagePopupsList';

import { SingleToast } from './SingleToast';
import type { ToastObject } from './types';

const DEFAULT_TRANSITION_TIME = 200;

export interface ControlledToastProps {
  transitionTime?: number;
  toasts: ToastObject[];
  onDismiss(id: string): void;
}

function ControlledToast({
  transitionTime = DEFAULT_TRANSITION_TIME,
  toasts,
  onDismiss,
}: ControlledToastProps) {
  return (
    <MessagePopupsList<ToastObject>
      transitionTime={transitionTime}
      position="bottom"
      messages={toasts}
    >
      {(message) => <SingleToast {...message} onRemove={() => onDismiss(message.id)} />}
    </MessagePopupsList>
  );
}

export default ControlledToast;
